/**
 * Shared form styles + a labelled field row for the Sites & Operators create
 * modals (Wave 3 / Quick 260615-uf9). Mirrors the inline-style idiom used by
 * NewJobModal / JobDetailModal.
 *
 * Moved from `features/management/form-bits.tsx` in Phase 26 / Task 26.5
 * (DEC-147 #10) when the Management console was retired. The 10 consumers
 * across sites-operators + setup-wizard + FleetPage were re-pointed to this
 * location — no runtime behavior change.
 */

import * as React from 'react';

export const fieldStyle: React.CSSProperties = {
  width: '100%',
  minHeight: '40px',
  padding: '8px 10px',
  fontSize: '14px',
  backgroundColor: 'var(--color-bg-tertiary)',
  border: '1px solid var(--color-border-secondary)',
  borderRadius: '10px',
  color: 'var(--color-text-primary)',
};

export const labelStyle: React.CSSProperties = {
  display: 'block',
  marginBottom: '4px',
  fontSize: '11px',
  fontWeight: 600,
  color: 'var(--color-text-tertiary)',
};

export function FormRow({
  label,
  htmlFor,
  required,
  children,
}: {
  label: string;
  htmlFor?: string;
  required?: boolean;
  children: React.ReactNode;
}): React.JSX.Element {
  return (
    <div>
      <label htmlFor={htmlFor} style={labelStyle}>
        {label}
        {required === true && <span style={{ color: 'var(--color-danger)' }}> *</span>}
      </label>
      {children}
    </div>
  );
}

/**
 * Operator tank registry PR 3 (0249): a hauler tank whose producer identifier is the operator
 * company's tank ID (or one of its tags) links to that tank automatically. Shown under a blank
 * identifier field only; a hint, nothing more.
 */
export const PRODUCER_ID_HINT =
  "Add the operator's tank ID so it links to their tank automatically.";

export function ProducerIdHint({
  id,
  value,
}: {
  id: string;
  value: string;
}): React.JSX.Element | null {
  if (value.trim() !== '') return null;
  return (
    <p
      id={id}
      style={{
        ...labelStyle,
        textTransform: 'none',
        letterSpacing: 'normal',
        fontWeight: 400,
        fontSize: '12px',
        marginTop: '4px',
        marginBottom: 0,
      }}
    >
      {PRODUCER_ID_HINT}
    </p>
  );
}
